import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries2/responsibleManager/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries2/responsibleManager/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries2/responsibleManager/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries2/responsibleManager/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries2/responsibleManager/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries2/responsibleManager/delete/${id}`)
    },
}